const animLogoData = [];

const colors = [
  "#B48CFF", "#8719FA", "#FF64FF", "#D20078", "#FF00D2", "#CB00E1",
  "#FF8280", "#E1001E", "#FFA532", "#FFE600", "#FFFF00", "#BEFF00",
  "#00FF87", "#00FF00", "#19FFFF", "#00CDD7", "#64D7FF", "#005AFF",
  "#EBE1FF", "#2D1964", "#FFF1FF", "#5A004B", "#FFFFB9", "#640A0A",
  "#F5EBE1", "#643205", "#CDFFC8", "#00A5B0", "#EBF5FF", "#373755",
  "#F5F5F5", "#787D82"
];

document.querySelectorAll(".animLogo").forEach((phraseContainer, index) => {
  if (!phraseContainer) return;

  let baseDuration = phraseContainer.classList.contains('animFooter') ? 1000 : 1000;
  const phraseText = phraseContainer.innerHTML;
  phraseContainer.innerHTML = "";
  let productPicElements = [];

  function setRandomImage(index) {
    let obj = productPicElements[index];
    let availableColors = colors.slice();
    let availableImages = images.slice();

    [index - 1, index + 1].forEach(n => {
      if (productPicElements[n]) {
				let neighborColor = productPicElements[n].currentColor;
				let neighborImage = productPicElements[n].currentImage;
				availableColors = availableColors.filter(c => c !== neighborColor);
        availableImages = availableImages.filter(img => img !== neighborImage);
      }
    });

		let randomColor = availableColors[Math.floor(Math.random() * availableColors.length)];
		let randomImage = availableImages[Math.floor(Math.random() * availableImages.length)];

    obj.currentColor = randomColor;
    obj.currentImage = randomImage;
    obj.element.style.background = randomColor;
    obj.element.style.backgroundImage = `url('${randomImage}')`;
    obj.element.style.backgroundSize = "contain";
    obj.element.style.backgroundRepeat = "no-repeat";
    obj.element.style.backgroundPosition = "center";
  }

  phraseText.split('').forEach(letter => {
    let div1 = document.createElement("div");
    div1.textContent = letter;
		div1.classList.add("slotMachineLetter")
    let wrapperDiv = document.createElement("div");
    wrapperDiv.classList.add("letter-wrapper");
    wrapperDiv.appendChild(div1);

    const fontSize = window.getComputedStyle(phraseContainer).fontSize;
    const fontSizeValue = parseFloat(fontSize) * 0.83;
    div1.style.height = fontSizeValue + "px";

    let productPic = false;
    if (letter === " ") {
      wrapperDiv.style.width = "0.25em";
    } else {
      productPic = document.createElement("div");
      productPic.classList.add("productPic");
      wrapperDiv.appendChild(productPic);
    }

    phraseContainer.appendChild(wrapperDiv);

    if (productPic) {
      let localIndex = productPicElements.length;
      productPicElements.push({ element: productPic, currentColor: null });

      setRandomImage(localIndex);

      let isAnimating = false;
      let baseDisplacement = 0;
      let startTime;
      let segmentDuration = baseDuration + Math.random() * 1500;
      let lastCycleIndex = 0;
			let imageAbove = false;

      const letterHeight = div1.offsetHeight * 1.03;
      wrapperDiv.dataset.letterHeight = letterHeight;
      wrapperDiv.dataset.targetDisplacement = 4 * letterHeight;

      function easeOutQuad(t) {
        return t * (2 - t);
      }

      function animateLetter() {
        let now = Date.now();
        let elapsed = now - startTime;
        let progress = Math.min(elapsed / segmentDuration, 1);
        let eased = easeOutQuad(progress);
        let letterHeight = parseFloat(wrapperDiv.dataset.letterHeight);
        let targetDisplacement = parseFloat(wrapperDiv.dataset.targetDisplacement);

        let currentTotal = baseDisplacement + eased * (targetDisplacement - baseDisplacement);
        let cycleIndex = Math.floor(currentTotal / letterHeight);
        let fraction = (currentTotal % letterHeight) / letterHeight;

        let pos1 = (cycleIndex % 2 === 0) ? -fraction * letterHeight : letterHeight - fraction * letterHeight;
				let pos2;
				if (pos1 < 0) {
					pos2 = pos1;
					if (imageAbove) {
						imageAbove = false;
						setRandomImage(localIndex);
					}
				} else {
					pos2 = pos1 - (2 * letterHeight);
					imageAbove = true;
				}

        div1.style.transform = `translateY(${pos1}px)`;
        productPic.style.transform = `translateY(${pos2}px)`;

				if (cycleIndex > lastCycleIndex) lastCycleIndex = cycleIndex;

        if (progress < 1) {
          requestAnimationFrame(animateLetter);
        } else {
          div1.style.transform = `translateY(0px)`;
          productPic.style.transform = `translateY(0px)`;
          isAnimating = false;
          baseDisplacement = 0;
          wrapperDiv.dataset.targetDisplacement = 4 * letterHeight;
					lastCycleIndex = 0;
        }
      }
			if (!("ontouchstart" in window)) {
				wrapperDiv.addEventListener("mouseenter", () => {
					let now = Date.now();
					if (!isAnimating) {
						isAnimating = true;
						startTime = now;
						requestAnimationFrame(animateLetter);
					} else {
						let elapsed = now - startTime;
						let progress = Math.min(elapsed / segmentDuration, 1);
						let eased = easeOutQuad(progress);
						let letterHeight = parseFloat(wrapperDiv.dataset.letterHeight);
						let targetDisplacement = parseFloat(wrapperDiv.dataset.targetDisplacement);
						let currentTotal = baseDisplacement + eased * (targetDisplacement - baseDisplacement);
						let currentCycles = Math.floor(currentTotal / letterHeight);
						let fraction = (currentTotal % letterHeight) / letterHeight;
						let finalCycle = currentCycles + (fraction > 0 ? 5 : 4);
						if (finalCycle % 2 !== 0) finalCycle++;
						baseDisplacement = currentTotal;
						wrapperDiv.dataset.targetDisplacement = finalCycle * letterHeight;
						startTime = now;
						segmentDuration = baseDuration + Math.random() * 1500;
					}
				});
			}
    }
  });
});

let resizeTimeout;

window.addEventListener('resize', () => {
  // clearTimeout(resizeTimeout);
  // resizeTimeout = setTimeout(() => {
    document.querySelectorAll(".animLogo").forEach(phraseContainer => {
      if (!phraseContainer) return;

      phraseContainer.querySelectorAll('.letter-wrapper div').forEach(div1 => {
        const fontSize = window.getComputedStyle(phraseContainer).fontSize;
        const fontSizeValue = parseFloat(fontSize) * 0.83;
        div1.style.height = fontSizeValue + "px";

        const letterHeight = div1.offsetHeight * 1.03;
        const wrapperDiv = div1.closest('.letter-wrapper');
        if (wrapperDiv) {
          wrapperDiv.dataset.letterHeight = letterHeight;
          wrapperDiv.dataset.targetDisplacement = 4 * letterHeight;
        }
      });
    });
  // }, 200);
});
